import {
  ITennisResults
} from "@sky-it-livedata/livedata-sports-design-system";
import { isNotEmptyArray } from "@sky-it-livedata-libraries/livedata-commons";
import { ResultsData } from "../types";
import { composeEmptyPlayers } from "../results-utils";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { CreateSdapiResultsWidgetInputSchema } from "appsync";

const isValidObject = (obj: ResultsData) =>
  Boolean(obj?.data?.getSdapiResultsWidget);

export const transformQuery = (obj: ResultsData): ITennisResults => {
  if (isValidObject(obj)) {
      CreateSdapiResultsWidgetInputSchema().parse(obj.data.getSdapiResultsWidget, {reportInput: true});
      const { matches, categoryName, date } = obj?.data?.getSdapiResultsWidget;

      return {
        categoryName,
        date,
        matches: matches?.map((match) => {
          return {
            ...match,
            firstPosition: {
              ...match?.firstPosition,
              players: isNotEmptyArray(match?.firstPosition?.players) ? match?.firstPosition?.players : composeEmptyPlayers(categoryName!),
            },
            secondPosition: {
              ...match?.secondPosition,
              players: isNotEmptyArray(match?.secondPosition?.players) ? match?.secondPosition?.players : composeEmptyPlayers(categoryName!),
            },
          }
        })
      } as ITennisResults;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in ResultsQuery object',
      data: obj
    });
  }
};